<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M2.25 6C2.25 3.92879 3.92879 2.25 6 2.25H9.555C9.96921 2.25 10.305 2.58579 10.305 3C10.305 3.41421 9.96921 3.75 9.555 3.75H6C4.75721 3.75 3.75 4.75721 3.75 6V14C3.75 15.2428 4.75721 16.25 6 16.25H14C15.2428 16.25 16.25 15.2428 16.25 14V10.455C16.25 10.0408 16.5858 9.705 17 9.705C17.4142 9.705 17.75 10.0408 17.75 10.455V14C17.75 16.0712 16.0712 17.75 14 17.75H6C3.92879 17.75 2.25 16.0712 2.25 14V6Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.1518 2.7711C15.4684 2.0863 14.3605 2.08724 13.677 2.77031C13.6769 2.77043 13.6771 2.77019 13.677 2.77031L7.97004 8.4693C7.8593 8.57988 7.78593 8.72233 7.7602 8.8767L7.2602 11.8767C7.22039 12.1156 7.2984 12.3591 7.46967 12.5303C7.64094 12.7016 7.88438 12.7796 8.1233 12.7398L11.1233 12.2398C11.2773 12.2141 11.4195 12.141 11.53 12.0307L17.2367 6.33201C17.9218 5.64859 17.9208 4.54019 17.2373 3.85667L16.1518 2.7711C16.1518 2.77118 16.1517 2.77101 16.1518 2.7711ZM15.09 3.83065C14.9934 3.73383 14.8358 3.73285 14.7373 3.83133L9.20023 9.36066L8.91241 11.0876L10.6399 10.7997L16.177 5.2703C16.2739 5.17372 16.2752 5.01581 16.1767 4.91733L15.09 3.83065Z"
            fill="currentColor"
        />
    </svg>
</template>
